document.addEventListener('DOMContentLoaded', () => {
  const termInput = document.querySelector('input#terms');
  if (!termInput) return;

  let checkoutBtn;

  if (window.location.pathname.includes("/cart")) {
    checkoutBtn = document.querySelector('button[name="checkout"]');
  } else {
    checkoutBtn = document.querySelector('.checkout-buttons [href="/checkout"]');
  }

  if (!checkoutBtn) return; 

  checkoutBtn.classList.add('bss-checkout-disabled');

  termInput.addEventListener('change', () => {
    checkoutBtn.classList.toggle('bss-checkout-disabled', !termInput.checked);
  });

   checkoutBtn.addEventListener("click", () => {
    checkoutBtn.classList.add('bss-checkout-disabled');
  });

  checkoutBtn.addEventListener("dblclick", () => {
    checkoutBtn.classList.add('bss-checkout-disabled');
  });
});

document.addEventListener('on:variant:change', () => {
  const variantInput = document.querySelector('.price-descriptors [action="/cart/add"] input[name="id"]');
  if (!variantInput) return;
  const variantId = variantInput.value;

  const targetElement = document.querySelector(
    `[bss-b2b-product-form-id] [bss-b2b-variant-id]`
  );
  if (targetElement) {
    targetElement.setAttribute('bss-b2b-variant-id', variantId);
  }
});
